import { render, staticRenderFns } from "./LocaleSwitch.vue?vue&type=template&id=1607d206&scoped=true&"
import script from "./LocaleSwitch.vue?vue&type=script&lang=ts&"
export * from "./LocaleSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LocaleSwitch.vue?vue&type=style&index=0&id=1607d206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1607d206",
  null
  
)

export default component.exports